module.exports = __webpack_public_path__ + "img/icon_fxzq.96ef29c8.png";